import { extractValueFromContext } from "core/utils/extractValueFromContext";
import { useUserPermissionContextsInCurrentBrandRegion } from "./useUserPermissionContextsInCurrentBrandRegion";

/**
 * Checks if the current user belongs to the "Shops" department in the current permission context.
 * @returns {boolean} Returns true if the user belongs to the "Shops" department, otherwise false.
 */
export function useIsShopUser(): boolean {
  const { contexts } = useUserPermissionContextsInCurrentBrandRegion();

  const departments =
    contexts
      ?.map(({ context }) => extractValueFromContext(context, "department"))
      .filter((val): val is string => typeof val === "string") ?? [];

  const roleTypes =
    contexts
      ?.map(({ context }) => extractValueFromContext(context, "role-type"))
      .filter((val): val is string => typeof val === "string") ?? [];

  return departments?.includes("Shops") || roleTypes.includes("shop");
}
